import { useState } from "react";
import { EVENTS } from "@/mocks/events";
import TopNav from "@/components/feature/TopNav";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import JsonLd from "@/components/feature/JsonLd";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import LatestFeed from "./components/LatestFeed";
import DeepFeature from "./components/DeepFeature";
import TopicsSection from "./components/TopicsSection";
import AboutSection from "./components/AboutSection";
import FaqSection, { HOMEFAGS } from "./components/FaqSection";

const origin = typeof window !== "undefined" ? window.location.origin : "";

export default function Home() {
  const [activeCategory, setActiveCategory] = useState("全部");

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: HOMEFAGS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  const itemListSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "吃瓜资讯最新事件专题",
    itemListElement: EVENTS.map((e, i) => ({
      "@type": "ListItem",
      position: i + 1,
      url: `${origin}/story/${e.id}`,
      name: e.title,
    })),
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "吃瓜资讯",
    description:
      "专注热点事件梳理、来龙去脉还原与背后真相深度解析的内容资讯站。",
    url: origin,
  };

  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "吃瓜资讯",
    url: origin,
    inLanguage: "zh-CN",
    description: "热点事件梳理 · 深度解析 · 完整时间线还原",
  };

  return (
    <>
      <JsonLd data={orgSchema} />
      <JsonLd data={webSiteSchema} />
      <JsonLd data={faqSchema} />
      <JsonLd data={itemListSchema} />

      <TopNav />
      <main>
        <Hero />
        <HotRank />
        <LatestFeed active={activeCategory} onPick={setActiveCategory} />
        <DeepFeature />
        <TopicsSection onPick={setActiveCategory} />
        <AboutSection />
        <FaqSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}